// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"31d6cfe0","384":"eb8e5848","664":"0f3ae155","910":"eb8e5848","947":"eb8e5848"}[chunkId] + ".chunk.css";
};